import api from '../service/api.service';

import { Case, CaseShort, CounselRole, PaginationQueryParams, ResultSet } from '../../types';
import { parseQueryFilters } from '../../helpers/parseQueryFilters';
import { parseQuerySortFields } from '../../helpers/parseQuerySortFields';

const BASE_URL = 'v1/fo/cases';

interface CreateCaseRequestBody {
  referenceId: string;
  secondaryFirms?: { id: number; role: CounselRole }[];
  clientId: number;
  defendants?: { id: number; grossSettlement?: number | null }[];
  caseTypeId: number;
  filedAt?: string | null;
  sol?: string | null;
  trustAccountId?: number | null;
}

type UpdateCaseRequestBody = Partial<CreateCaseRequestBody>;

export const getCases = async ({
  size,
  page,
  count = false,
  match = '',
  filters,
  activeSortField,
  includeArchived = false,
  leadFirmOnly = false,
}: PaginationQueryParams & { leadFirmOnly?: boolean }) => {
  const queryFilters = parseQueryFilters(filters);
  const sortFilters = parseQuerySortFields(activeSortField);

  const targetUrl = `${BASE_URL}?size=${size}&page=${page}&match=${match}${queryFilters}${sortFilters}&count=${count}&includeArchived=${includeArchived}&leadFirmOnly=${leadFirmOnly}`;

  return await api.get<ResultSet<CaseShort>>(targetUrl);
};

export const createCase = async (data: CreateCaseRequestBody) => {
  return await api.post<Case>(BASE_URL, data);
};

export const getCase = async (id: number) => {
  const targetUrl = `${BASE_URL}/${id}`;

  return await api.get<Case>(targetUrl);
};

export const updateCase = async (id: number, data: UpdateCaseRequestBody) => {
  const targetUrl = `${BASE_URL}/${id}`;

  return await api.put<Case>(targetUrl, data);
};

/**
 * Remove Case. Case must be in "draft" status.
 */
export const deleteCase = async (id: number) => {
  const targetUrl = `${BASE_URL}/${id}`;

  return await api.delete<void>(targetUrl);
};

export const exportCases = async ({
  match = '',
  filters,
  activeSortField,
  includeArchived = false,
}: Omit<PaginationQueryParams, 'page' | 'size'>) => {
  const queryFilters = parseQueryFilters(filters);
  const sortFilters = parseQuerySortFields(activeSortField);

  const targetUrl = `${BASE_URL}/export?&match=${match}${queryFilters}${sortFilters}&includeArchived=${includeArchived}`;

  return await api.post<string>(targetUrl, null, { responseType: 'blob' });
};

export const submitCase = async (id: number) => {
  const targetUrl = `${BASE_URL}/${id}/submit`;

  return await api.post<void>(targetUrl);
};

export const abandonCase = async (id: number) => {
  const targetUrl = `${BASE_URL}/${id}/abandon`;

  return await api.post<void>(targetUrl);
};
